import { useScrollLock as useBaseUIScrollLock } from '@base-ui/utils/useScrollLock';

/**
 * Locks page scroll while `locked` is true, restoring it on unlock/unmount.
 *
 * Delegates to Base UI's own scroll-lock utility — the same one its
 * `Popover`/`Dialog` call internally when rendered `modal` — rather than a
 * plain `overflow: hidden` toggle, which does not reliably block scroll on
 * iOS Safari (it ignores `touchmove`). Base UI's own lock explicitly skips
 * touch-opened popovers (`openMethod !== 'touch'`), but a real tap on a
 * mobile trigger *is* that, so a bottom sheet opened by tapping doesn't stop
 * the page behind it from scrolling. Call this alongside such a sheet's own
 * open state to lock scroll independent of how it was opened. Sharing Base
 * UI's underlying lock also means this coordinates correctly (via its
 * internal reference count) with any of its own components locking scroll
 * at the same time, rather than two independent locks fighting over the
 * same inline style.
 */
const useScrollLock = (locked: boolean): void => {
  useBaseUIScrollLock(locked);
};

export default useScrollLock;
